import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    /* eslint-disable no-dupe-keys */
    height: '100vh',
    height: 'calc(var(--vh, 1vh) * 100)',
    overflow: 'auto',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.sidebarWidthClose,
      transition: theme.transitions.create('padding', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  contentExpanded: {
    paddingLeft: theme.sidebarWidth,
  },
  contentLanding: {
    paddingLeft: 'inherit',
  },
  mainContainer: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4, 7),
    },
  },
}))

export default useStyles
